var map = {
	"./G2A.png": 7850,
	"./a-brand.png": 5874,
	"./acer.png": 5095,
	"./agoda.png": 292,
	"./aliexpress.png": 5859,
	"./almundo.png": 7825,
	"./amaro.png": 6813,
	"./amazon-br.png": 3432,
	"./americanas.png": 5297,
	"./animale.png": 3964,
	"./asus.png": 7555,
	"./bang-good.png": 1637,
	"./booking.png": 7891,
	"./boticario.png": 2747,
	"./brastemp.png": 1777,
	"./carrefour.png": 8042,
	"./casa-das-aliancas.png": 5868,
	"./casa-e-construcao.png": 4127,
	"./casa-show.png": 4514,
	"./casas-bahia.png": 8414,
	"./cea.png": 5922,
	"./centauro.png": 8593,
	"./central-ar.png": 8060,
	"./chicoreibr.png": 5872,
	"./click-bus.png": 4766,
	"./cobasi.png": 5766,
	"./compra-certa.png": 7325,
	"./consul.png": 6439,
	"./corpo-ideal.png": 7285,
	"./dafiti.png": 4793,
	"./deal-extreme.png": 9322,
	"./decathlonbr.png": 7254,
	"./dell.png": 6939,
	"./dolce-gusto.png": 2207,
	"./droga-raia.png": 3107,
	"./drogaria-araujo.png": 6543,
	"./drogarias-pacheco.png": 5252,
	"./drogasil.png": 2296,
	"./dulorenbr.png": 4710,
	"./ebay.png": 3901,
	"./electrolux.png": 6945,
	"./etna.png": 7456,
	"./expedia.png": 792,
	"./extra.png": 7088,
	"./farfetchbr.png": 8007,
	"./fastshop.png": 6464,
	"./foto-registro.png": 4987,
	"./foxton.png": 3449,
	"./fut-fanatics.png": 8246,
	"./gearbest.png": 7283,
	"./girafa.png": 2625,
	"./giuliana-flores.png": 4076,
	"./gocase.png": 5861,
	"./hoteis-com.png": 8318,
	"./hotel-urbano.png": 158,
	"./hp.png": 2744,
	"./iplace.png": 7884,
	"./kabum.png": 4310,
	"./kitchen-aid.png": 5052,
	"./kutiz.png": 4957,
	"./latam.png": 7270,
	"./lenovo.png": 1034,
	"./livraria-cultura.png": 4813,
	"./loccitane-au-bresil.png": 8119,
	"./loccitane.png": 3949,
	"./lojas-rede.png": 1839,
	"./mac-cosmeticos.png": 886,
	"./madesa.png": 8852,
	"./magazine-luiza.png": 3471,
	"./malwee.png": 6840,
	"./marabraz.png": 7142,
	"./marcyn.png": 2543,
	"./marisa.png": 2168,
	"./mobly.png": 8471,
	"./motorola.png": 3040,
	"./multilaser.png": 1581,
	"./natura.png": 6370,
	"./netshoes.png": 591,
	"./nicephotos.png": 5439,
	"./nikebr.png": 9070,
	"./nuuvem.png": 9088,
	"./off-premium.png": 2982,
	"./onofre-eletro.png": 8819,
	"./pandora.png": 7173,
	"./petz.png": 2574,
	"./phooto.png": 6631,
	"./plie.png": 3564,
	"./polishop.png": 6532,
	"./ponto-frio.png": 5457,
	"./positivo.png": 6356,
	"./posthaus.png": 8404,
	"./renner.png": 9036,
	"./ri-happy.png": 9875,
	"./ricardo-eletro.png": 7487,
	"./sephora.png": 6906,
	"./sestinibr.png": 7997,
	"./shopee.png": 6838,
	"./shoptime.png": 4210,
	"./sou-barato.png": 2001,
	"./spicy.png": 9456,
	"./sub-viagens.png": 9349,
	"./submarino.png": 1794,
	"./telhanorte.png": 8790,
	"./vaio.png": 6655,
	"./viajanet.png": 9147,
	"./wine.png": 9685,
	"./youcom.png": 8821,
	"./zattini.png": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4919;